/**
 * Wachttijden voor tooltips, in milliseconden.
 *
 * Eén plek en geen kopie per scherm: twee gelijke getallen met een comment
 * ernaast lopen uiteen zodra er één wordt bijgesteld, en beide kanten houden
 * dan groene tests.
 * AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
 */

/**
 * De titel in een gegevenstabel. Lang genoeg dat er niets opspringt bij het
 * scheren over de tabel — élke rij heeft een tooltip — en kort genoeg dat je
 * niet staat te wachten als je een afgekapte titel wilt lezen.
 */
const DATA_TITLE_TOOLTIP_DELAY = 1000

export { DATA_TITLE_TOOLTIP_DELAY }
